<template>
  <v-layout
    v-if="room && featuresField && room[featuresField] && Object.keys(room[featuresField]).length > 0"
    wrap
  >
    <v-flex xs12 pt-3 pb-1>
      <h3>{{ title }} {{ room.number }}</h3>
    </v-flex>
    <template
      v-for="featureId in Object.keys(room[featuresField]).filter(featureId => {
        return featuresList[featureId] && room[featuresField][featureId].checked === true
        })"
    >
      <v-flex
        :key="featureId + '_quantity'"
        xs1 class="text-xs-right" pr-1
      >
        <template v-if="room[featuresField][featureId].quantity">
          {{ room[featuresField][featureId].quantity }} x
        </template>
      </v-flex>
      <v-flex
        xs1
        :key="featureId + '_icon'"
        text-xs-center
      >
        <v-icon small style="width: 30px;">
          {{ featuresList[featureId].icon }}
        </v-icon>
      </v-flex>
      <v-flex
        xs10
        :key="featureId + '_name'"
      >
        {{ capitalize(featuresList[featureId]['name_' + lang]) +
        (room[featuresField][featureId].distance
          ? ': ' + room[featuresField][featureId].distance
          : '') }}
          {{  }}
      </v-flex>
    </template>
  </v-layout>
</template>

<script>
import sharedMethods from './../methods/sharedMethods'
import { createHelpers } from 'vuex-map-fields'
import state from './../state.js'
const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})

export default {
  name: 'ObjectRoomFeatures',

  props: {
    featuresField: {
      type: String,
      default: null
    },
    room: {
      type: Object,
      default: () => {
        return {}
      }
    },
    title: {
      type: String,
      default: null
    }
  },

  computed: {
    ...mapFields(Object.keys(state))
  },

  methods: {
    ...sharedMethods
  }
}
</script>
